import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { Functions } from '@/library/utils/functions';
import { IPSService } from '@/services/ipsServices';

/**
 * 优惠券类型(cpnType)
 */
export enum CRMCouponType {
  COUPON_DISCOUNT = 0, // 折扣券
  COUPON_MONEY = 1, // 金额券
  COUPON_GIFT = 2, // 礼品券
  COUPON_PRICE = 3, // 定价券
  COUPON_SHIPPING = 4, // 包邮券
  COUPON_COMMON = 6, // 通用券
  COUPON_THIRD_VENDOR = 7, // 外部券
}

const CouponTypeList = [
  { type: CRMCouponType.COUPON_DISCOUNT, name: '折扣券' },
  { type: CRMCouponType.COUPON_MONEY, name: '金额券' },
  { type: CRMCouponType.COUPON_GIFT, name: '礼品券' },
  { type: CRMCouponType.COUPON_PRICE, name: '定价券' },
  { type: CRMCouponType.COUPON_SHIPPING, name: '包邮券' },
  { type: CRMCouponType.COUPON_COMMON, name: '通用券' },
  { type: CRMCouponType.COUPON_THIRD_VENDOR, name: '外部券' },
];

@DialogFactory
@Component({
  mixins: [style],
})
export default class Coupon extends IPSDialog {
  page = 1;

  pageSize = 10;

  total = 0;

  dataList = [];

  keyword = '';

  siteCodes = [];

  confirm = false;

  title = '优惠券列表';

  width = '800px';

  cancelText = '关闭';

  params = {};

  mounted() {
    this.getCouponList();
  }

  getCouponList() {
    const postParams = Object.assign({}, { page: this.page, keyword: this.keyword, pageSize: this.pageSize, siteCodes: this.siteCodes }, this.params);
    IPSService.couponList({
      postParams,
    }).then((response) => {
      this.total = response.count;
      const result = response.list;
      this.dataList = result.map((v) => {
        return Object.assign({}, v, {
          time: `${Functions.timeFormatSec(moment(v.isuSTime * 1000).unix())}~${Functions.timeFormatSec(moment(v.isuETime * 1000).unix())}`,
        });
      });
    });
  }

  onSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getCouponList();
  }

  onPageChange(val) {
    this.page = val;
    this.getCouponList();
  }

  onSelect(cplId, cplName, type) {
    this.$emit('result', { id: cplId, name: cplName, type });
    this.$emit('hidden');
  }

  handleSearch() {
    this.page = 1;
    this.getCouponList();
  }

  renderContent(h) {
    return (
      <div class="select-list">
        <div class="filterController">
          <div class="r-mr-12">
            <el-input v-model={this.keyword} placeholder="券型编号、券名称"></el-input>
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)}></i>
          </div>
        </div>
        <el-table data={this.dataList} height="350px" style="width: 100%" tooltip-effect="light">
          <el-table-column type="index" label="ID" width="55" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="cplId" label="券型编号" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="cplName" label="券名称" width="180" show-overflow-tooltip></el-table-column>
          <el-table-column
            prop="cpnType"
            label="券类型"
            width="180"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{CouponTypeList.find(v => v.type === scope.row.cpnType) ? CouponTypeList.find(v => v.type === scope.row.cpnType).name : '/'}</span>;
                },
              },
            }}></el-table-column>
          <el-table-column prop="time" label="可发放期间" width="320" show-overflow-tooltip></el-table-column>
          <el-table-column
            label="操作"
            width="80px"
            fixed="right"
            align="center"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span class="scopeSpan" onClick={this.onSelect.bind(this, scope.row.cplId, scope.row.cplName, CouponTypeList.find(v => v.type === scope.row.cpnType) ? CouponTypeList.find(v => v.type === scope.row.cpnType).name : '/')}>
                      选中
                    </span>
                  );
                },
              },
            }}></el-table-column>
        </el-table>
        <div class="bottomWrapper">
          <el-pagination
            on-size-change={val => this.onSizeChange(val)}
            on-current-change={val => this.onPageChange(val)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.total}></el-pagination>
        </div>
      </div>
    );
  }
}
